export function textareaAutoHeightDirective() {
  "njInject";
  return {
    link: function link($scope, $element) {
      var textArea = $element[0];
      if (textArea.nodeName !== 'TEXTAREA') return console.warn("textareaAutoHeightDirective must be used with <textarea>, got ".concat(textArea.nodeName));

      textArea.style.minHeight || (textArea.style.minHeight = '20px');
      textArea.addEventListener('input', onChange);
      textArea.addEventListener('paste', onChange);
      textArea.addEventListener('change', onChange);

      setTimeout(onChange);

      function onChange() {
        textArea.style.height = '';
        textArea.style.height = "".concat(textArea.scrollHeight + 2, "px");
      }

      return function () {
        textArea.removeEventListener('input', onChange);
        textArea.removeEventListener('paste', onChange);
        textArea.removeEventListener('change', onChange);
      };
    } };

}